// src/hooks/useGallery.ts
import { useState, useCallback } from 'react';
import { galleryImages, GalleryImage } from '../data/galleryImages';

export const useGallery = () => {
  const [selectedImage, setSelectedImage] = useState<GalleryImage | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>('all');
  const [currentIndex, setCurrentIndex] = useState(0);

  const categories = ['all', ...Array.from(new Set(galleryImages.map(img => img.category)))];
  
  const filteredImages = activeCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeCategory);

  const featuredImages = galleryImages.filter(img => img.featured);

  const openImage = useCallback((image: GalleryImage) => {
    setSelectedImage(image);
    setCurrentIndex(filteredImages.findIndex(img => img.id === image.id));
  }, [filteredImages]);

  const closeImage = useCallback(() => {
    setSelectedImage(null);
  }, []);

  const nextImage = useCallback(() => {
    setCurrentIndex(prev => {
      const next = prev + 1;
      return next >= filteredImages.length ? 0 : next;
    });
    setSelectedImage(filteredImages[currentIndex + 1] || filteredImages[0]);
  }, [filteredImages, currentIndex]);

  const prevImage = useCallback(() => {
    setCurrentIndex(prev => {
      const next = prev - 1;
      return next < 0 ? filteredImages.length - 1 : next;
    });
    setSelectedImage(filteredImages[currentIndex - 1] || filteredImages[filteredImages.length - 1]);
  }, [filteredImages, currentIndex]);

  const selectCategory = useCallback((category: string) => {
    setActiveCategory(category);
    setSelectedImage(null);
    setCurrentIndex(0);
  }, []);

  return {
    images: filteredImages,
    featuredImages,
    categories,
    selectedImage,
    activeCategory,
    currentIndex,
    openImage,
    closeImage,
    nextImage,
    prevImage,
    selectCategory,
  };
};